export interface VehicleRegistrationData {
  vin: string;
  registrationPlate: string;
  /** ISO date (`YYYY-MM-DD`) so browser drafts and the API stay timezone-free. */
  firstRegistrationInCountry: string | null;
}

export const EMPTY_VEHICLE_REGISTRATION_DATA: VehicleRegistrationData = {
  vin: '',
  registrationPlate: '',
  firstRegistrationInCountry: null,
};

export function normalizeVehicleRegistrationData(value?: Partial<VehicleRegistrationData> | null): VehicleRegistrationData {
  return {
    vin: String(value?.vin || '').trim().toUpperCase(),
    registrationPlate: String(value?.registrationPlate || '').trim().toUpperCase(),
    firstRegistrationInCountry: value?.firstRegistrationInCountry || null,
  };
}

export function isVehicleRegistrationDataValid(value: VehicleRegistrationData): boolean {
  if (!value.firstRegistrationInCountry) {
    return true;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.firstRegistrationInCountry);
  if (!match) {
    return false;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  // Date normalizes invalid values such as 2026-02-31 into March. Reject
  // those rather than silently accepting a different registration date.
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date <= today;
}
